import LayoutBasic from "@/views/layouts/LayoutBasic";
import EmptyLayout from "@/views/layouts/EmptyLayout";
import settingsAccessUsers from "@/views/admin/settings/access/users";
import SettingsAccessRedis from "@/views/admin/settings/access/Redis";
import settingsAccessUsersEdit from "@/views/admin/settings/access/editUser";
import settingsAccessRoles from "@/views/admin/settings/access/roles";
import settingsAccessRoleEdit from "@/views/admin/settings/access/editRole";
import settingsStoresMain from "@/views/admin/settings/stores/main";
import settingsStoresCities from "@/views/admin/settings/stores/cities";
import settingsCurrenciesRates from "@/views/settings/currencies/rates";
import SettingsStoresWorkingTime from "@/views/admin/settings/stores/WorkingTime";
import SettingsStoresTelegramNotifications from "@/views/admin/settings/stores/TelegramNotifications";
import settingsOrdersDeliveryPrice from "@/views/admin/settings/orders/deliveryPrices";
import settingsCardsList from "@/views/admin/settings/cards/list";
import settingsCardsNew from "@/views/admin/settings/cards/new";
import settingsLettersList from "@/views/admin/settings/letters/list";
import settingsOrdersReserve from "@/views/admin/settings/orders/reserve";
import CardReport from "@/views/cards/Report";
import SettingsInvoiceSubstatuses from "@/views/admin/settings/invoices/SettingsInvoiceSubstatuses.vue";
import GeneralSettings from "@/views/settings/GeneralSettings.vue";

const routes = {
  path: '/settings',
  component: LayoutBasic, // Change the desired Layout here
  meta: {requiresAuth: true},
  children: [
    {
      path: 'general',
      name: 'GeneralSettings',
      component: GeneralSettings,
      meta: {
        permission: 'settings/general'
      }
    },
    {
      path: 'letters/list',
      name: 'settingsLettersList',
      component: settingsLettersList
    },
    {
      path: 'invoices',
      meta: {requiresAuth: true},
      component: EmptyLayout,
      children: [
        {
          path: 'substatuses',
          name: 'settingsInvoiceSubstatuses',
          component: SettingsInvoiceSubstatuses
        }
      ]
    },
    {
      path: 'orders',
      meta: {requiresAuth: true},
      component: EmptyLayout,
      children: [
        {
          path: 'reserve',
          name: 'settingsOrdersReserve',
          component: settingsOrdersReserve
        },
        {
          path: 'dprice',
          name: 'settingsOrdersDeliveryPrice',
          component: settingsOrdersDeliveryPrice
        },
      ]
    },
    {
      path: 'cards',
      meta: {requiresAuth: true},
      component: EmptyLayout,
      children: [
        {
          path: 'list',
          name: 'settingsCardsList',
          component: settingsCardsList
        },
        {
          path: 'new/:id',
          name: 'settingsCardsNewEdit',
          component: settingsCardsNew
        },
      ]
    },
    {
      path: 'currencies/rates',
      component: settingsCurrenciesRates,
      name: 'settingsCurrenciesRates',
      meta: {
        permission: 'settings/currencies/rates'
      },
    },
    {
      path: 'access',
      meta: {requiresAuth: true},
      component: EmptyLayout,
      children: [
        {
          path: 'users',
          name: 'settingsAccessUsers',
          component: settingsAccessUsers
        },
        {
          path: 'redis',
          name: 'SettingsAccessRedis',
          component: SettingsAccessRedis
        },
        {
          path: 'users/:id',
          name: 'settingsAccessUsersEdit',
          component: settingsAccessUsersEdit
        },
        {
          path: 'roles',
          name: 'settingsAccessRoles',
          component: settingsAccessRoles
        },
        {
          path: 'roles/:id',
          name: 'settingsAccessRoleEdit',
          component: settingsAccessRoleEdit
        },
      ]
    },
    {
      path: 'stores',
      meta: {requiresAuth: true},
      component: EmptyLayout,
      children: [
        {
          path: 'store',
          name: 'settingsStoresMain',
          component: settingsStoresMain
        },
        {
          path: 'cities',
          name: 'settingsStoresCities',
          component: settingsStoresCities
        },
        {
          path: 'workingtime',
          component: SettingsStoresWorkingTime,
          name: 'SettingsStoresWorkingTime',
          meta: {
            // allowedTo: [ROLES.ID.SuperAdmin],
            // permission: 'clients/blackList'
          }
        },
        {
          path: 'notifications',
          component: SettingsStoresTelegramNotifications,
          name: 'SettingsStoresTelegramNotifications',
          meta: {}
        },

      ]
    }
  ]
}

export default routes;
